// /accounts/$accountSlug — index route under the layout above.
// Renders the actual AccountDetailPage. Siblings (./tenants/...,
// ./tenants/$tenantSlug, ...) are leaf routes that take over the
// layout's <Outlet />.

import { createFileRoute } from "@tanstack/react-router";

import { AccountDetailPage } from "../features/accounts/AccountDetailPage";

export const Route = createFileRoute("/accounts/$accountSlug/")({
  component: AccountDetailRoute,
});

function AccountDetailRoute() {
  const { accountSlug } = Route.useParams();
  return <AccountDetailPage accountSlug={accountSlug} />;
}
